import React from 'react'
import styled from 'styled-components'

import BgImage from '../../assets/images/bg3.png'

const Wrapper = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 140vh;
  background: #171717;
  background: top left no-repeat;
  background-image: url(${BgImage});
  background-size: cover;
  transition: all 0.3s ease;

  ${({ theme }) => theme.media.l} {
    flex-direction: row;
  }
`

const BackgroundImage = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  height: 350px;
  background: ${({ theme }) => theme.colors.black};

  :before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: #171717;
    animation: loaded 0.6s ease 0.6s 1 forwards;
  }

  :after {
    ${({ image }) => image && 'content: "";'}
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.black} top right no-repeat;
    background-image: url(${({ image }) => image});
    background-position: center center;
    background-size: cover;
    opacity: 0.5;
  }

  > div {
    z-index: 2;
  }

  p {
    position: absolute;
    top: 325px;
    left: 145px;
    z-index: 2;
    font-size: 38px;
    line-height: 0.8;
    font-weight: ${({ theme }) => theme.font.bold};

    span {
      position: absolute;
      bottom: -5px;
      left: -7px;
      max-width: 55px;
      font-size: 14px;
      line-height: 1.2;
      transform: rotate(270deg);
      transform-origin: bottom left;
      opacity: 0.3;
    }

    :after {
      position: absolute;
      right: 0;
      bottom: -10px;
      width: 0%;
      height: 1px;
      background: #a98e67;
      animation: loadedRev 0.6s ease 0.6s 1 forwards;
      content: '';
    }
  }

  @keyframes loaded {
    from {
      width: 100%;
    }
    to {
      width: 0%;
    }
  }

  @keyframes loadedRev {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }

  ${({ theme }) => theme.media.l} {
    position: absolute;
    right: 0;
    width: ${({ halfWidth }) => (halfWidth ? '50%' : '40%')};
    height: 100%;

    p {
      top: 20%;
      left: -85px;
      font-size: 48px;
    }
  }
`

const Container = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.maxContentWidth};
  margin: 0 auto;
  padding: 100px 30px 100px;

  ${({ theme }) => theme.media.m} {
    padding: 140px 30px 100px;
  }

  ${({ theme }) => theme.media.l} {
    padding: 180px 50px 100px;
    padding: 180px ${({ halfWidth }) => (halfWidth ? '50%' : '40%')} 100px 50px;
  }

  ${({ theme }) => theme.media.xl} {
    padding-top: 240px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding-top: 360px;
  }
`

const ContainerInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.maxContentWidth};

  > span {
    margin: 0 0 10px;
    font-size: 42px;
    font-weight: ${({ theme }) => theme.font.light};
  }

  > h2 {
    position: relative;
    margin: 0 0 25px;
    font-size: 120px;
    line-height: 0.85;

    > span {
      font-weight: ${({ theme }) => theme.font.bold};
    }
  }

  > h4 {
    margin: 0 0 20px;
    font-size: 24px;
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.primary};
  }

  ${({ theme }) => theme.media.l} {
    padding: 0 50px 0 0;

    > h4 {
      margin: 0 0 25px;
      font-size: 30px;
    }
  }
`

const TwoColumnHero = ({ halfWidth, image, imageContent, children }) => (
  <Wrapper>
    <BackgroundImage halfWidth={halfWidth} image={image}>
      {imageContent && imageContent}
    </BackgroundImage>
    <Container halfWidth={halfWidth}>
      <ContainerInner>{children}</ContainerInner>
    </Container>
  </Wrapper>
)

export default TwoColumnHero
